import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {MenuComponent} from './menu.component';
import {MenuItemComponent} from './menu-item.component';
import {MenuGroupComponent} from './menu-group/menu-group.component';
import {ContentModule} from '../../../shared/directives/content.module';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SelectFilterModule} from '../select-filter/select-filter.module';
import {MatIconModule} from '@angular/material/icon';
import {
    AccountChangeDialogModule
} from '../../../modules/account/common/api/component/account-change-dialog/account-change-dialog.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        ContentModule,
        SelectFilterModule,
        MatIconModule,
        AccountChangeDialogModule,
    ],
    declarations: [
        MenuComponent,
        MenuItemComponent,
        MenuGroupComponent,
    ],
    exports: [
        MenuComponent,
        ContentModule,
    ],
})
export class MenuModule {}
